import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_ANALYTIC } from "../../constants";

export const getPeoplePage = createAsyncThunk(
  "people/page",
  async (param, thunkAPI) => {
    let parameter = ''
    if(param.filter.siteId !== ''){
      parameter += '&siteId='+param.filter.siteId
      if(param.filter.waktu === 'daily'){
        parameter += '&waktu='+param.filter.waktu
        if(param.filter.date !== ''){
          parameter += '&date='+param.filter.date
        }
      }else if(param.filter.waktu === 'monthly'){
        parameter += '&waktu='+param.filter.waktu
        if(param.filter.month !== ''){
          parameter += '&month='+param.filter.month
        }        
      } else {
        parameter += '&waktu='+param.filter.waktu
        if(param.filter.year !== ''){
          parameter += '&year='+param.filter.year
        }
      }
    }
    let urlAPI = `${API_ANALYTIC}/api/dashboard-laporan?analyticId=PPLCNT${parameter}`
    const respone = await fetch(urlAPI, {
      method: 'get',
      headers: new Headers({
        Authorization: 'Bearer ' + param.token,
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Credentials': 'true',
      }),
    })
    if (respone.status === 200) {
      const responeResult = await respone.json();
      // console.log("as")
      return responeResult;
    } else {
      return {
        data: {
          totalElements: 0,
          totalPages: 0,
          last: true,
          size: 0,
          number: 0,
          numberOfElements: 0,
          first: true,
          empty: false,
        },
      };
    }
  }
);

